const { bootstrap } = window;

export class SignatureBadge
{
	buttonId = '';
	button = null;
	popover = null;
	transitionTimeout = 0;
	downloadDisable = false;

	constructor(options = {})
	{
		this.buttonId = options.buttonId || '';
		BX.ready(BX.delegate(this.init,this));
	}

	init()
	{
		this.button = document.getElementById(this.buttonId);

		if (!this.button)
			return false;

		this.popover = new bootstrap.Popover(this.button, {
			html: true,
			trigger: 'manual',
		});

		this.button.addEventListener(
			'mouseenter',
			() => {
				this.showPopover();
			}
		);

		this.button.addEventListener(
			'mouseleave',
			() => {
				this.hidePopover();
			}
		);

		this.button.addEventListener(
			'inserted.bs.popover',
			() => {
				this.popover.tip.addEventListener(
					'mouseenter',
					() => {
						this.showPopover();
					}
				);
				this.popover.tip.addEventListener(
					'mouseleave',
					() => {
						this.hidePopover();
					}
				);
			}
		);

		if (this.isTouch())
		{
			this.button.addEventListener(
				'show.bs.popover',
				() => {
					this.downloadDisable = true;
					setTimeout(() => { this.downloadDisable = false; });
				}
			);

			this.button.addEventListener(
				'click',
				(event) => {

					if (this.downloadDisable)
						event.preventDefault();
				}
			);
		}
	}

	showPopover()
	{
		clearTimeout(this.transitionTimeout);
		this.popover.show();
	}

	hidePopover()
	{
		this.transitionTimeout = setTimeout(() => {
			this.popover.hide();
		}, 300);
	}

	isTouch()
	{
		return document.documentElement.classList.contains('bx-touch');
	}
}
